import _ from 'lodash';

export const getDocumentTypesForAccount = (account, formData) => {
  if (!account) {
    return [];
  }

  const {
    documentTypes: accountTypes,
    industries: accountIndustries,
  } = account;

  if (!accountIndustries) {
    return [];
  }

  const { industries: formIndustries } = formData;

  const documentTypes = accountIndustries
    .map(industry => _.find(formIndustries, { id: industry }))
    .reduce(
      (types, industry) => types.concat(_.get(industry, 'documentTypes', [])),
      []
    )
    .concat(accountTypes);

  return documentTypes;
};
